import React from 'react';
import { Row, Col, Panel } from 'rsuite';
import * as images from '../../images/charts';
import { Link } from 'react-router-dom';
import { Icon } from '@rsuite/icons';
import BarLineChartIcon from '@rsuite/icons/BarLineChart';
import AdminIcon from '@rsuite/icons/Admin';
import PeoplesUploadedIcon from '@rsuite/icons/PeoplesUploaded';
import TagIcon from '@rsuite/icons/Tag';
import DetailIcon from '@rsuite/icons/Detail';
import TextImageIcon from '@rsuite/icons/TextImage';
import TrendIcon from '@rsuite/icons/Trend';


const Dashboard = () => {
  return (
    <>

      <div className='maindash' style={{ 'width': '100%', 'marginLeft': '2px' }}>

        <div className='dflex'>

          <Link className='link' to="/products">
            <div className='dashdiv'>

              <Icon className='iconimg' style={{ 'width': '64px', 'height': '72px', 'color': 'cadetblue' }} as={TextImageIcon} />
              <h5 className='fontw'>Manage Product</h5>
              <br />
              <p>You Can View, Manage, Add Your Product.</p>

            </div>
          </Link>

          <Link className='link' to="/selection">
            <div className='dashdiv'>
              <Icon className='iconimg' style={{ 'width': '64px', 'height': '72px', 'color': 'cadetblue' }} as={BarLineChartIcon} />
              <h5 className='fontw'>Catalogue Create</h5>
              <br />
              <p>You Can View, Manage, Create Your Catalogue.</p>
            </div>
          </Link>

          <Link className='link' to="/manageCatalogue">
            <div className='dashdiv'>
              <Icon className='iconimg' style={{ 'width': '64px', 'height': '72px', 'color': 'cadetblue' }} as={DetailIcon} />
              <h5 className='fontw'>Manage Catalogue</h5>
              <br />
              <p>You Can View, Manage, Update Your Catalogue.</p>
            </div>
          </Link>
        </div>
        <div className='dflex'>
          <Link className='link' to="/manageCollection">
            <div className='dashdiv'>
              <Icon className='iconimg' style={{ 'width': '64px', 'height': '72px', 'color': 'cadetblue' }} as={TrendIcon} />
              <h5 className='fontw'>Manage Collection</h5>
              <br />
              <p>You Can View, Manage Your Collection.</p>
            </div>
          </Link>
          <Link className='link' to="/addbuyer">
            <div className='dashdiv'>
              <Icon className='iconimg' style={{ 'width': '64px', 'height': '72px', 'color': 'cadetblue' }} as={AdminIcon} />
              <h5 className='fontw'>Buyer</h5>
              <br />
              <p>You Can View, Manage, Add Your Buyers.</p>
            </div>
          </Link>
          <Link className='link' to="/dashboard">
            <div className='dashdiv'>
              <Icon className='iconimg' style={{ 'width': '64px', 'height': '72px', 'color': 'cadetblue' }} as={PeoplesUploadedIcon} />
              <h5 className='fontw'>Buyer recommendations</h5>
              <br />
              <p>You Can Recommend Buyers for Catalogues.</p>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Dashboard;